import React from 'react';
import Grid from '@mui/material/Grid2';

const MuiCol = ({ children,align_center, ...props }) => {

  if(align_center)
    props.sx={
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      ...props.sx,
    }

  return (
    <Grid {...props}>
      {children}
    </Grid>
  );
};

export default MuiCol;